var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobVoltaShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #879fa0;\n      }\n\n      .cls-2 {\n        fill: #00bcb7;\n      }\n\n      .cls-3 {\n        fill: #9fbec1;\n      }\n\n      .cls-4 {\n        fill: #b4d1d6;\n      }\n\n      .cls-5 {\n        fill: aqua;\n      }\n\n      .cls-6 {\n        fill: #ff88a4;\n      }\n\n      .cls-7 {\n        fill: #738d8e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "600.95 437.19 559.09 443.48 471.98 443.48 471.98 369.34 600.95 388.7 600.95 437.19"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "617.93 288.47 128.38 358.89 .88 428.48 533.31 428.48 617.93 288.47"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "527.11 442.81 44.65 442.81 .3 427.88 530.61 427.88 527.11 442.81"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "421.18 476.37 196.95 465.26 196.95 452.54 421.18 441.44 421.18 476.37"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "605.95 482.6 396.85 478.77 312.6 427.53 534.05 427.53 605.95 482.6"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "302.14 371.72 128.38 357.69 526.88 233.47 706.67 213.46 618.45 288.81 302.14 371.72"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "128.38 357.69 -.02 428.65 170.64 428.65 618.94 289.23 128.38 357.69"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "613.82 493.18 431.05 489.76 396.28 478.2 605.35 482.6 613.82 493.18"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "277.33 427.46 1.09 428.88 187.3 406.06 618.04 289.98 277.33 427.46"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "389.02 322.08 127.96 357.68 265.79 298.35 480.3 215.29 389.02 322.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobVoltaShip);
export default __webpack_public_path__ + "static/media/mob-volta-ship.ec6ab7bee38f64e91602ecf27e368a65.svg";
export { ForwardRef as ReactComponent };